import { ReactNode } from 'react';
import * as S from './styles';

type FeedbackMessageProps = {
  children: ReactNode;
  marginTop?: number;
};

const FeedbackMessage = ({ children, marginTop }: FeedbackMessageProps) => {
  return <S.Text marginTop={marginTop}>{children}</S.Text>;
};

export default FeedbackMessage;
